import { Box, Button, Grid, Menu } from "@mui/material";
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from "react";

import styles from "./styles";

interface IProps {
  id: string;
  label: string;
  children: ReactNode;
  isSmallScreen: boolean;
  close?: boolean;
  setClose?: Dispatch<SetStateAction<boolean>>;
}

export default function DropdownSelect({
  id,
  label,
  children,
  isSmallScreen,
  close,
  setClose,
}: IProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [showChildren, setShowChildren] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    if (setClose) setClose(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const idName = open ? id : undefined;

  const displaySubmenu = () => {
    setShowChildren((prev) => !prev);
  };

  useEffect(() => {
    if (close) {
      handleClose();
    }
  }, [close]);

  const arrowIcon = (
    <Box
      component="i"
      className={`fa-regular fa-chevron-${open ? "up" : "down"}`}
      sx={styles.arrow}
    />
  );

  const dropdownBtn = (
    <Button
      variant="text"
      size="small"
      color={open ? "success" : "inherit"}
      sx={{ textTransform: "none", fontSize: 12 }}
      aria-describedby={idName}
      onClick={handleClick}
    >
      {label} {arrowIcon}
    </Button>
  );

  return (
    <>
      {isSmallScreen ? (
        <Grid
          onClick={displaySubmenu}
          container
          justifyContent="space-between"
          alignItems="center"
          sx={styles.mobileList}
        >
          <Box sx={{ fontSize: 16 }}>{label}</Box> {arrowIcon}
        </Grid>
      ) : (
        dropdownBtn
      )}

      {!isSmallScreen && (
        <Menu
          id={idName}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={open}
          onClose={handleClose}
        >
          {children}
        </Menu>
      )}

      {isSmallScreen && showChildren && (
        <Box sx={styles.children}>{children}</Box>
      )}
    </>
  );
}
